export const handleRemoveField = (
  fieldId: string,
  form: any,
  setForm: React.Dispatch<React.SetStateAction<any[]>>,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const newItems = form.filter((item: any) => item.uuid !== fieldId);
  setForm(newItems);
  setButtonSave(true);
};
